function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M.972.908a1.5 1.5 0 012.12.064l8.47 9a1.5 1.5 0 010 2.056l-8.47 9a1.5 1.5 0 11-2.184-2.056L8.41 11 .908 3.028A1.5 1.5 0 01.972.908z"
});

var SvgArrowRight = function SvgArrowRight(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 12 22",
    fill: "currentColor"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTIgMjIiIGZpbGw9ImN1cnJlbnRDb2xvciIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuOTcxOTU3IDAuOTA3NzA0QzEuNTc1MjIgMC4zMzk5MyAyLjUyNDUzIDAuMzY4Njk3IDMuMDkyMyAwLjk3MTk1N0wxMS41NjI5IDkuOTcxOTZDMTIuMTA2NSAxMC41NDk1IDEyLjEwNjUgMTEuNDUwNSAxMS41NjI5IDEyLjAyODFMMy4wOTIzIDIxLjAyOEMyLjUyNDUzIDIxLjYzMTMgMS41NzUyMiAyMS42NjAxIDAuOTcxOTU3IDIxLjA5MjNDMC4zNjg2OTcgMjAuNTI0NSAwLjMzOTkzIDE5LjU3NTIgMC45MDc3MDQgMTguOTcyTDguNDEwNzIgMTFMMC45MDc3MDQgMy4wMjgwNUMwLjMzOTkzIDIuNDI0NzkgMC4zNjg2OTcgMS40NzU0OCAwLjk3MTk1NyAwLjkwNzcwNFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { SvgArrowRight as ReactComponent };